import 'regenerator-runtime/runtime';
import moment from 'moment';

const firebaseConfig = {
  apiKey: "AIzaSyDihtfSzBfTr35lc7fRQ0PYSwurMZGuU3Y",
  authDomain: "prd-stc-yol.firebaseapp.com",
  projectId: "prd-stc-yol",
  storageBucket: "prd-stc-yol.appspot.com",
  messagingSenderId: "1053185451187",
  appId: "1:1053185451187:web:c77b626227267737037cc6"
};

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";


firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();
console.log(firestore);

async function send_tracker(customerName, customerId, pageName, pageIndex, parentName, parentId){
    firebase.auth().onAuthStateChanged(async (user)=>{if(user){
      const url = window.location.href;
      
      try {
          // document作ってsubcollection作らないとorphanになっちゃうのでsub doc作る
          const ref = firestore.collection("log").doc(moment().format("YYYY-MM"));
          const doc = await ref.get();
          if(!doc.exists){
             await firestore.collection("log")
            .doc(moment()
            .format("YYYY-MM")).set({},{ merge: true })
          }

          const rsl = await firestore
            .collection("log")
            .doc(moment()
            .format("YYYY-MM"))
            .collection("logs")
            .add({
              timestamp: firebase.firestore.FieldValue.serverTimestamp(),
              customerName,
              customerId,
              pageName,
              pageIndex,
              parentId: parentId || "",
              parentName: parentName || "",
              fullUrl: url
            })        
          console.log("tracking is valid");
      } catch(e) {
          console.error("tracking is invalid");
      }
    }    
    })
    await firebase.auth().signInAnonymously();
}

window.send_tracker = send_tracker;